import { useForm } from 'react-hook-form'
import toast from 'react-hot-toast'
import { yupResolver } from '@hookform/resolvers/yup'
import { createStore } from 'utils/api/storeApi'
import { createStoreSchema } from 'utils/schema/storeSchema'
import { AxiosError } from 'axios'
import { ERROR_CODES, PAGE_STORE_MGMT } from 'utils/constants'
import { Button } from 'components/common'
import { StoreDetailsForm } from 'components/storeManagement'
import BackButton from 'components/backButton'
import { useNavigate } from 'react-router-dom'
import { StoreFormData } from 'components/storeManagement/utils'

const CreateStorePage = () => {
  const {
    register,
    handleSubmit,
    reset,
    setValue,
    formState: { errors },
  } = useForm<StoreFormData>({ resolver: yupResolver(createStoreSchema) })

  const navigate = useNavigate()

  const handleCreateStore = async (data: StoreFormData) => {
    const toastStore = toast.loading('Creating store...')

    try {
      await createStore(data)
      reset()
      toast.success('Store created successfully', { id: toastStore })
      navigate(PAGE_STORE_MGMT.path)
    } catch (error) {
      if (error instanceof AxiosError) {
        const msg = error?.response?.data?.errors?.msg

        if (msg === ERROR_CODES.STORE_ALREADY_EXISTS) {
          return toast.error('Store with code already exist.', {
            id: toastStore,
          })
        }
      }
      toast.error('Failed to create store', { id: toastStore })
    }
  }

  return (
    <>
      <BackButton />

      <form onSubmit={handleSubmit(handleCreateStore)}>
        <StoreDetailsForm
          setValue={setValue}
          register={register}
          errors={errors}
        />

        <Button buttonText="Create Store" className="mt-7 w-44" />
      </form>
    </>
  )
}

export default CreateStorePage
